import fileRepository from '../../backend/FileRepository'
import { OK } from '../../utils/const'

const state = {
    apiStatus: null,
    message: null
}

const getters = {
    apiStatus: state => !! state.apiStatus,
    getMessage: state => state.message
}

const mutations = {
    setApiStatus(state, status) {
        state.apiStatus = status
    },
    setMessage(state, message) {
        state.message = message
    }
}

const actions = {

    // csvファイルをアップロードする
    async uploadCsv(context, file) {
        context.commit('setApiStatus', null)
        const response = await fileRepository.importCsv(file)

        if (response.status === OK) {
            context.commit('setApiStatus', true)
            context.commit('setMessage', 'アップロードに成功しました')
            return
        }

        context.commit('setApiStatus', false)
        context.commit('setMessage', 'システムエラーが発生しました')
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}